/**
 * Shared white-paper catalog.
 *
 * Consumed by:
 *   - /resources (Resources hub page)
 *   - /admin/whitepapers (Admin sales resource surface)
 *   - Individual white-paper pages (for meta tag injection)
 *
 * Each entry MUST have a matching route wired in App.js and a matching
 * markdown file in /public/whitepapers/{id}.md.
 */
export const WHITEPAPERS = [
  {
    id: "cost-of-cash-pay-programs",
    title: "The Real Cost of Building a Consumer-Centric Cash-Pay Program",
    tag: "Program design",
    read_minutes: 14,
    published: "Feb 2026",
    published_iso: "2026-02-01",
    summary:
      "An honest accounting of the time and staffing required to develop, deploy, and manage outsourced cash-pay programs — where the vendors deliver, and the clinic runs the operating layer.",
    public_path: "/resources/cost-of-cash-pay-programs",
    markdown_path: "/whitepapers/cost-of-cash-pay-programs.md",
    pdf_path: "/whitepapers/cost-of-cash-pay-programs.pdf",
    pdf_size_kb: 320,
    pdf_pages: 14,
    og_image_path: "/og/cost-of-cash-pay-programs.png",
    use_when: [
      "Prospect is comparing DIY vs. platform (\"we could just build this ourselves\")",
      "CFO / practice owner is skeptical of the operational cost of vendor coordination",
      "Multi-program clinic considering standing up a second or third cash-pay line",
    ],
  },
];

export function findWhitepaper(id) {
  return WHITEPAPERS.find((w) => w.id === id) || null;
}
